module.exports = __webpack_public_path__ + "static/media/repair-s.4ff50c62.svg";